export default "__VITE_ASSET__69ed35c8__"